import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button } from 'react-bootstrap';
import '../css/general.css';
import { getJersey } from "../race/C4FLeaderJerseys";
import C4FSimpleTable from "../common/C4FSimpleTable";
import { UserInformationContext, ReferenceDataContext } from "../main/App";
import { C4FStatusContext } from "../main/App";
import { getCountryName, getUnicodeFlag, getC4FCodeForCountryCode } from "../common/Helpers";

function NationalChampionships(props) {
  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { countries } = useContext(ReferenceDataContext);
  const [team, setTeam] = useState(null);
  const [raceEditions, setRaceEditions] = useState(null);
  const navigate = useNavigate();

  function showRace(raceEditionId) {
    navigate('/race', { state: { raceEditionId: raceEditionId } });
  }

  function loadTeam() {
    handleBackendRequest('GET', '/team/' + userInformation.userName, null, { returnRiders: true }, setTeam);
  }

  function loadRaceEditions() {
    handleBackendRequest('GET', '/raceEdition', null, { context: 'today' }, setRaceEditions);
  }

  useEffect(() => {
    loadRaceEditions();
    loadTeam();
  }, []);


  if (team !== null && raceEditions !== null)
    return (
      <Container fluid className="m-0 p-0 justify-content-center">
        <Row className=" m-1 p-1 justify-content-center">
          <Col className="m-1 px-3">
            <h4>National Championships</h4>
            <Row className="c4f-stats">
              <C4FSimpleTable key={'nationalChampionships'}
                initialSortingColumn={'startingTimeSort'}
                initialSortingAscending={true}
                hideFilterButtons={true}
                data={team.riders
                  .filter(rider => rider.nationality && rider.age > 20)
                  .map(rider => {
                    let raceEdition = raceEditions.some(re => re.race.country === rider.nationality) ? 
                      raceEditions.find(re => re.race.country === rider.nationality) : null
                    let raceEditionId = raceEdition ? raceEdition.id : null;
                    let status = raceEdition ? raceEdition.raceEditionStatus : 'None';
                    let startingTime = raceEdition ? raceEdition.startingTime : 99;
                    let currentSector = raceEdition ? raceEdition.currentSector : 0;
                    
                    return {
                      ...rider,
                      riderName: rider.firstNames + ' ' + rider.lastNames,
                      flag: getUnicodeFlag(rider.nationality),
                      c4fCode: getC4FCodeForCountryCode(countries, rider.nationality),
                      nation: getCountryName(countries, rider.nationality),
                      raceEditionId: raceEditionId,
                      raceButton: <Button sime="sm" 
                        disabled={['None', 'Cancelled'].includes(status)} 
                        variant={['None', 'Cancelled'].includes(status) ? 'outline-danger' : 'primary'} 
                        onClick={() => showRace(raceEditionId)}>{status === 'InProgress' ?
                          (currentSector <= 1 ? 'Startlist' : 'Live') : status}</Button>,
                      numberOfParticipants: raceEdition ? raceEdition.numberOfParticipants : 0,
                      km: currentSector,
                      startingTimeSort: startingTime,
                      startingTime: startingTime,
                      jersey: rider.nationality === 'UN' ? '' : <img alt={rider.nationality} src={getJersey('', 'NC_' + rider.nationality)} style={{ maxHeight: "25px" }} />
                  }})}
                rowMetadata={[
                  { columnName: 'riderName', columnDescription: 'Rider' },
                  browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' },
                  { columnName: 'nation', columnDescription: 'Nation' },
                  { columnName: 'jersey', columnDescription: 'Jersey', columnType: 'object' },
                  { columnName: 'startingTime', columnDescription: 'Time' },
                  { columnName: 'numberOfParticipants', columnDescription: 'Teams' },
                  { columnName: 'km', columnDescription: 'km' },
                  { columnName: 'raceButton', columnDescription: 'Race', columnType: 'object' }
                ]}
              />
            </Row>
          </Col>

        </Row>
      </Container>
    );
  else return null;
}

export default NationalChampionships;
